import Modal from "./Modal";

export default function ConfirmModal({ isOpen, onClose, onConfirm, loading, title, message }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} maxWidth="max-w-xs">
            <div className="p-6 text-center">
                <h3 className="text-lg font-bold text-black mb-2">
                    {title || "Are you sure?"}
                </h3>
                <p className="text-sm text-gray-500 mb-6">
                    {message || "This action cannot be undone."}
                </p>
                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 py-2.5 rounded-xl border border-gray-200 text-sm font-semibold text-gray-600 hover:bg-gray-50 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={loading}
                        className="flex-1 py-2.5 rounded-xl bg-red-500 text-white text-sm font-semibold hover:bg-red-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                        {loading ? "Logging out..." : "Yes, Logout"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}